import { FILTER_KEY_MAP } from "@/pages/dashboard/_config/constant";
import { formatFilterValues } from "@/pages/dashboard/utils/utils";

interface IFunnelFilterValue {
  custom_filters?: Array<{
    key: string;
    filter_list: string[];
  }>;
  [key: string]: any;
}

interface IFormattedFilterValue {
  [key: string]: string[] | any;
}

/**
 * 将 custom_filters 中的 key 和 value 平铺到顶层
 * @param filterValue - 包含 custom_filters 的筛选器值对象
 * @returns 平铺后的筛选器值对象，custom_filters 中的项会被映射到顶层
 */
export const formatFunnelFilterValues = (oFilterValue: IFunnelFilterValue): IFormattedFilterValue => {
  const filterValue = formatFilterValues(oFilterValue);
  if (!filterValue) {
    return {};
  }

  const obj = { ...(filterValue || {}) };
  // API 返回的数据结构，使用下划线命名，解构时转换为 camelCase
  const { custom_filters: customFilters, ...restFilters } = obj;

  // 如果没有 custom_filters，直接返回原对象（排除 custom_filters）
  if (!customFilters || !Array.isArray(customFilters) || customFilters.length === 0) {
    return restFilters;
  }

  // 将 custom_filters 中的 key 和 value 平铺到顶层
  const flattenedFilters = { ...restFilters };
  customFilters?.forEach((item: { key: string; filter_list: any[]; }) => {
    if (item?.key && item?.filter_list) {
      // 使用 FILTER_KEY_MAP 映射 key，如果没有映射则使用 key + '_list'
      const mappedKey = (item.key in FILTER_KEY_MAP)
        ? FILTER_KEY_MAP[item.key as keyof typeof FILTER_KEY_MAP]
        : `${item.key}_list`;
      flattenedFilters[mappedKey] = item.filter_list;
    }
  });

  return flattenedFilters;
};